<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <ul class="list-group list-group-flush" v-for="(validationConfiguration, index) in validationConfigurations" v-show="!loading">
                    <li class="list-group-item">
                        {{validationConfiguration.label}}
                        <label class="switch ">
                            <input type="checkbox" class="primary" v-model="validationConfiguration.isActive">
                            <span class="slider round"></span>
                        </label>
                    </li>
                </ul>
                <button class="btn btn-primary" @click="saveValidationConfigurations" v-show="!loading">
                    Save
                </button>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    
        
</div>
